import { useContext } from 'react';
import { OnboardingContext, OnboardingContextType } from './OnboardingContext';

/**
 * Hook to access onboarding context
 * @throws Error if used outside of OnboardingProvider
 */
export const useOnboarding = (): OnboardingContextType => {
  const context = useContext(OnboardingContext);

  if (context === undefined) {
    throw new Error('useOnboarding must be used within an OnboardingProvider');
  }

  return context;
};

export default useOnboarding;
